import React from "react";

function MovementDetailModal(props) {
    const { movimento, onClose, onEdit, onDelete } = props;
    const isEntrata = movimento.eu;

    return (
        <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
                
                {/* Intestazione con Badge Entrata/Uscita */}
                <div style={styles.headerContainer}>
                    <h2>Dettaglio Movimento</h2>
                    <span style={{
                        ...styles.badge, 
                        backgroundColor: isEntrata ? 'rgba(34, 197, 94, 0.15)' : 'rgba(239, 68, 68, 0.15)',
                        color: isEntrata ? '#22c55e' : '#ef4444',
                        border: `1px solid ${isEntrata ? '#22c55e' : '#ef4444'}`
                    }}>
                        {isEntrata ? '🟢 Entrata' : '🔴 Uscita'}
                    </span>
                </div>
                
                {/* Card dei dettagli */}
                <div style={styles.detailsContainer}>
                    <div style={styles.row}>
                        <span style={styles.label}>Soggetto</span>
                        <span style={styles.value}>{movimento.soggetto || 'Non specificato'}</span>
                    </div>

                    <div style={styles.row}>
                        <span style={styles.label}>Importo</span>
                        <span style={{
                            ...styles.value, 
                            fontWeight: 'bold', 
                            fontSize: '1.1rem',
                            color: isEntrata ? '#22c55e' : '#ef4444'
                        }}>
                            {isEntrata ? '+' : '-'} € {Number(movimento.importo).toFixed(2)}
                        </span>
                    </div>

                    <div style={styles.row}>
                        <span style={styles.label}>Descrizione</span>
                        <span style={styles.value}>{movimento.descrizione || 'Nessuna descrizione'}</span>
                    </div>

                    <div style={styles.row}>
                        <span style={styles.label}>Metodo / Conto</span>
                        <span style={styles.value}>
                            {movimento.nome ? 
                            (movimento.conto ? `${movimento.nome} (${movimento.conto})` : movimento.nome) 
                            : 'Non specificato'}
                        </span>
                    </div>

                    <div style={styles.rowLast}>
                        <span style={styles.label}>Data</span>
                        <span style={styles.value}>
                            {movimento.data ? new Date(movimento.data).toLocaleDateString('it-IT') : 'Non specificata'}
                        </span>
                    </div>
                </div>

                {/* Pulsanti di azione */}
                <div style={styles.modalButtons}>
                    <button onClick={() => onEdit(movimento)} style={styles.editBtn}>Modifica</button>
                    <button onClick={() => onDelete(movimento.id_movimento)} style={styles.deleteBtn}>Elimina</button>
                    <button onClick={onClose} style={styles.cancelBtn}>Chiudi</button>
                </div>
            </div>
        </div>
    );
}

const styles = {
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        backdropFilter: 'blur(4px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
    },
    modalContent: {
        backgroundColor: '#1e293b',
        padding: '28px',
        borderRadius: '16px',
        width: '100%',
        maxWidth: '420px',
        color: '#ffffff',
        border: '1px solid #334155',
        boxShadow: '0 25px 30px -10px rgba(0,0,0,0.6)',
        textAlign: 'center',
    },
    headerContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '15px',
    },
    badge: {
        padding: '4px 10px',
        borderRadius: '20px',
        fontSize: '0.8rem',
        fontWeight: 'bold',
    },
    detailsContainer: {
        textAlign: 'left',
        margin: '15px 0',
        backgroundColor: '#0f172a',
        padding: '6px 16px',
        borderRadius: '10px',
        border: '1px solid #334155',
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 0',
        borderBottom: '1px solid #1e293b',
    },
    rowLast: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 0',
    },
    label: {
        color: '#94a3b8',
        fontSize: '0.9rem',
    },
    value: {
        color: '#f8fafc',
        fontSize: '0.95rem',
        textAlign: 'right',
        maxWidth: '220px',
        wordBreak: 'break-word',
    },
    modalButtons: {
        display: 'flex',
        gap: '10px',
        marginTop: '20px',
    },
    editBtn: {
        flex: 1,
        backgroundColor: '#3b82f6',
        color: '#ffffff',
        border: 'none',
        padding: '11px',
        borderRadius: '8px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'background 0.2s',
    },
    deleteBtn: {
        flex: 1,
        backgroundColor: '#ef4444',
        color: '#ffffff',
        border: 'none',
        padding: '11px',
        borderRadius: '8px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'background 0.2s',
    },
    cancelBtn: {
        flex: 1,
        backgroundColor: 'transparent',
        color: '#cbd5e1',
        border: '1px solid #475569',
        padding: '11px',
        borderRadius: '8px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'background 0.2s',
    }
};

export default MovementDetailModal;
